<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <ion-fab vertical="bottom" horizontal="end" *ngIf="app.linkToOpenViaFab">
    <ion-fab-button target="_blank" [href]="app.linkToOpenViaFab" (click)="app.linkToOpenViaFab = null">
      <ion-icon icon="open" />
    </ion-fab-button>
  </ion-fab>
</ion-app>
